import React from "react";
import { Cow } from "../../assets/svg";
import { Wrapper } from "./styles";

interface EmptyProps {
  title: string;
  subTitle: string;
}

const Empty = ({ subTitle, title }: EmptyProps) => {
  return (
    <Wrapper>
      <Cow />
      <span>{title}</span>
      <span>{subTitle}</span>
    </Wrapper>
  );
};

export { Empty };
